<script setup lang="ts">
import { useUIStore } from "@/stores";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { snackbar, closeSnackbar } = useUIStore();
</script>
<template>
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="2000" top>
    {{ snackbar.message }}
    <template v-slot:actions>
      <v-btn @click="closeSnackbar">{{ t('close') }}</v-btn>
    </template>
  </v-snackbar>
</template>
